package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.SelectedCardBg
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp

@Composable
fun DetailsCards(
    titles: List<String>, modifier: Modifier, selectedCard: MutableState<Int>
) {
    Column(
        modifier = modifier.padding(top = 10.toScaleDp())
    ) {
        titles.forEachIndexed { index, title ->
            DisableSelection {
                Text(
                    text = title,
                    fontSize = 16.toScaleSp(),
                    fontWeight = if (selectedCard.value == index || titles.size == 1) FontWeight.W700 else FontWeight.W400,
                    color = if (selectedCard.value == index || titles.size == 1) BlueApp else Color.Gray,
                    modifier = modifier.background(if (selectedCard.value == index || titles.size == 1) SelectedCardBg else Color.White)
                        .clickableWithPointer { selectedCard.value = index }.drawBehind {
                            if (selectedCard.value == index || titles.size == 1) {
                                drawLine(
                                    color = BlueApp,
                                    start = Offset(1f, 0f),
                                    end = Offset(1f, size.height),
                                    strokeWidth = 2f
                                )
                            }
                        }.padding(14.toScaleDp()),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }
    }
}